import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'

const url = 'use-cases'
const plural = 'usecases'
const single = 'usecase'

const api = new ApiCore({
	index: true,
	findOne: true,
	create: false,
	update: false,
	remove: false,
	url: url,
	plural: plural,
	single: single
})

api.massUpdate = () => {
	// Custom API Logic
}

api.index = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}`,params)
		.then(handleResponse)
		.catch(handleError);
}

api.findOne = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/?useCaseId=${params}`)
		.then(handleResponse)
		.catch(handleError);
}

api.getUseCase = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/list`)
		.then(handleResponse)
		.catch(handleError);
}

export default api
